var accessToken = BYOB_STOREFRONT_ACCESS_TOKEN

function initBYOBQuickview(vm) {

    var productId = vm.product.id;
    var gid = "gid://shopify/Product/" + productId;
    const quickviewContainer = document.querySelector('.byob-modal-wrapper');
    const closeBtn = document.querySelector('.byob-quickview-close');
    createTriggerButton(quickviewContainer, closeBtn, "Go Back" );

    fetch('/api/2024-01/graphql.json', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': accessToken
        },
        body: JSON.stringify({
            query: `
            query {
            node(id: "${gid}") {
            ... on Product {
            title
            features: metafield(namespace: "custom", key: "features") {
            value
            type
            }
            warranty: metafield(namespace: "custom", key: "warranty") {
            value
            type
            }
            weight: metafield(namespace: "custom", key: "weight") {
            value
            type
            }
            dimensions: metafield(namespace: "custom", key: "dimensions") {
            value
            type
            }
            shipping: metafield(namespace: "custom", key: "shipping") {
            value
            type
            }
            }
            }
            }`
        })
    })
    .then(res => res.json())
    .then((data) => {
  const node = data.data.node;

  // Map your metafields (label + key from GraphQL response)
  const metafields = [
    { label: 'Features', value: node.features?.value },
    { label: 'Warranty', value: node.warranty?.value },
    { label: 'Weight', value: node.weight?.value },
    { label: 'Dimensions', value: node.dimensions?.value },
    { label: 'Shipping', value: node.shipping?.value }
  ];

  const existingDiv = document.querySelector('#details');

  if (existingDiv) {
    const wrapper = document.createElement('div');
    wrapper.className = 'bundle-dropdown-wrapper';

    metafields.forEach(field => {
      if (!field.value) return; // skip empty metafields

      const html = toHTML(field.value);

      // Create dropdown container
      const dropdown = document.createElement('div');
      dropdown.className = 'bundle-dropdown';

      // Create tab
      const tab = document.createElement('button');
      tab.className = 'bundle-dropdown-tab';
      tab.innerHTML = `${field.label} <span class="chevron">▼</span>`;

      // Create content
      const content = document.createElement('div');
      content.className = 'bundle-dropdown-content';
      content.innerHTML = html;
      content.style.display = 'none';

      // Toggle
      tab.addEventListener('click', () => {
        const isOpen = content.style.display === 'block';

        content.style.display = isOpen ? 'none' : 'block';
        tab.querySelector('.chevron').style.transform = isOpen
          ? 'rotate(0deg)'
          : 'rotate(180deg)';
      });

      dropdown.appendChild(tab);
      dropdown.appendChild(content);
      wrapper.appendChild(dropdown);
    });

    // Insert once (cleaner DOM)
    existingDiv.parentNode.insertBefore(wrapper, existingDiv.nextSibling);
  }
});
}

function toHTML(content) {
	let parsed = JSON.parse(content);
	let html = '';
	parsed.children.forEach((node) => {
		switch (node.type) {
			case 'heading':
				html += ``;
				break;
			case 'list':
				html += `<${node.listType === 'unordered' ? 'ul' : 'ol'}>`;
				node.children.forEach((item) => {
					html += `<li> ${item.children[0].value} </li>
`;
				});
				html += `<${node.listType === 'unordered' ? '/ul' : '/ol'}>`;
				break;
			case 'paragraph':
				html += `

`;
				node.children.forEach((item) => {
					if (item.type === 'text' && item.bold) {
						html += `${item.value}` + ' ';
					} else if (item.type === 'text' && item.italic) {
						html += `${item.value}` + ' ';
					} else if (item.type === 'text') {
						html += `${item.value}` + ' ';
					}
					if (item.type === 'link' && item.bold) {
						html +=
							`${item.children[0].value}` +
							' ';
					} else if (item.type === 'link' && item.italic) {
						html +=
							`${item.children[0].value}` +
							' ';
					} else if (item.type === 'link') {
						html +=
							`${item.children[0].value}` + ' ';
					}
				});
				html += `

`;
				break;
		}
	});
	return html;
}

function createTriggerButton(parentEl, targetButton, text = 'Go Back') {
  if (!parentEl || !targetButton) return null;

  const btn = document.createElement('button');
  btn.className = 'bundle-trigger-btn';

  // Create arrow element
  const arrow = document.createElement('span');
  arrow.className = 'arrow';

  // // Optional label
  // const label = document.createElement('span');
  // label.className = 'label';
  // label.textContent = text;

  btn.appendChild(arrow);
  // btn.appendChild(label);

  // Click behavior
  btn.addEventListener('click', () => {
    targetButton.click();
  });

  parentEl.appendChild(btn);

  return btn;
}